<template>
    <div class="basket-items">
        <div class="loader" v-show="loading"></div>

        <div v-for="product in products" class="basket-item">
            <div class="basket-item__image-wrapper">
                <img class="basket-item__image" :src="product.img.big" :alt="product.name" height="165">

                <div class="product-label">
                    <div v-for="label in product.labels" :key="label" :class="`product-label__item product-label__item--${label}`"></div>
                </div>
            </div>

            <div class="basket-item__name">{{ product.name }}</div>
            <div class="basket-item__description">{{ product.desc }}</div>
            <div class="basket-item__meta">{{ product.quantityInProduct }} шт / {{ product.weight.value }} {{ product.weight.unit }}</div>
            <div class="basket-item__price-one currency">{{ product.price | numberFormat }}</div>
            <product-counter :product="product"></product-counter>
            <div class="basket-item__price currency currency--top">{{ product.price * product.count | numberFormat }}</div>
            <div class="btn btn--remove btn--remove--type-2" @click="$eventBus.$emit('sendCart', { type: 'forget', productId: product.index })"></div>

            <div class="basket-item__modifiers">
                <ul>
                    <li v-for="modifier in getAllModifiers(product)">
                        <template v-if="modifier.value > 1">
                            x{{ modifier.value }}
                        </template>

                        {{ modifier.name }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['products'],
        methods: {
            statsMetrics(name) {
                this.$root.statsMetrics(name);
            },
            forgetCart(id) {
                this.$eventBus.$emit("sendCart", {
                    type: 'forget',
                    productId: id
                });
            },
            modalOpen(name) {
                document.winLoad(() => {
                    this.$root.openModal('selectOrderType', name);
                })
            },
            getAllModifiers(product) {
                return [...product.modifiers.filter((modifier) => modifier.value), ...product.groupModifiers.reduce((carry, groupModifiers) => {
                    return [...carry, ...groupModifiers.modifiers.filter((modifier) => modifier.value)];
                }, [])];
            }
        },
        computed: {
            disabledDelivery() {
                return this.loading;
            },
            emptyBasket() {
                if (this.loadedBasket === false) {
                    return false;
                }

                return this.basket.cart.count === 0
                    && (this.basket.cart.unavailableGoods === undefined || Object.keys(this.basket.cart.unavailableGoods).length === 0);
            },
            loadedBasket() {
                return this.basket.loaded;
            },
            subtotal() {
                return this.basket.cart.price.total;
            },
            loading() {
                return !this.$root.basket.loaded;
            }
        }
    }
</script>
